import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconArrowRightProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconArrowRightSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconArrowRightSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M2.66669 8.84667H10.1267L8.73335 10.24L9.91335 11.42L13.3334 8L9.92002 4.58667L8.74002 5.76L10.1667 7.18667H2.66669V8.84667Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconArrowRightSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M3 8.50666H11.08L9.12667 10.46L9.82667 11.16L13 7.98666L9.83333 4.82666L9.12667 5.52666L11.1133 7.51333H3V8.50666Z" />
    </svg>
  );
}

export default function IconArrowRight({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconArrowRightProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
